export default __webpack_public_path__ + "static/media/left-arrow.d7d88e30.svg";